module.exports = __webpack_public_path__ + "static/media/icons_Bilan Lombalgie commune.4ed1330d.svg";